import createAsyncActionType from "../../../utilities/createAsyncActionType";

export const GET_WATCH_LIST_ENTRIES_HIGH_RISK_COUNTRIES = createAsyncActionType(
  "GET_WATCH_LIST_ENTRIES_HIGH_RISK_COUNTRIES"
);

export const CREATE_WATCH_LIST_ENTRY_HIGH_RISK_COUNTRIES =
  createAsyncActionType("CREATE_WATCH_LIST_ENTRY_HIGH_RISK_COUNTRIES");

export const DELETE_WATCH_LIST_ENTRY_HIGH_RISK_COUNTRIES =
  createAsyncActionType("DELETE_WATCH_LIST_ENTRY_HIGH_RISK_COUNTRIES");

export const CLEAR_WATCH_LIST_ENTRIES_HIGH_RISK_COUNTRIES =
  "CLEAR_WATCH_LIST_ENTRIES_HIGH_RISK_COUNTRIES";

export const SET_WATCH_LIST_ENTRY_HIGH_RISK_COUNTRIES_SEARCH_FILTERS =
  "SET_WATCH_LIST_ENTRY_HIGH_RISK_COUNTRIES_SEARCH_FILTERS";

export const SET_NO_ENTRIES_MESSAGE_HIGH_RISK_COUNTRIES =
  "SET_NO_ENTRIES_MESSAGE_HIGH_RISK_COUNTRIES";



// WEBPACK FOOTER //
// ./src/features/watch-list-entry-high-risk-country/types/watchListEntryTypes.js